import React from "react";
import "./stat.styles.scss";
import { connect } from "react-redux";
export const InventoryManager = ({ firstName }) => {
  return (
    <>
      <div
        className="container"
        style={{ width: "80rem", position: "relative", left: "7.8rem" }}
      >
        <div
          className="container-fluid welcome-head bg-white mt-4 p-4"
          style={{ border: "1px solid #d8dbe0" }}
        >
          <h2>
            Hi, <strong>{firstName}</strong>
          </h2>
          <p>
            Welcome to <strong>{localStorage.getItem("companyName")}</strong>{" "}
            dashboard{" "}
          </p>
        </div>

        <div className="container-fluid mt-3">
          {/* <div className="row">
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white homeCard mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="text-primary m-0">
                    {" "}
                    <strong> No of Users</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("users")} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong> No of Locations</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("locations")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong> No of Products</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("products")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className=" m-0 text-primary">
                    {" "}
                    <strong> Product Categories</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("productCategory")}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row">
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white homeCard mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="text-primary m-0">
                    {" "}
                    <strong> Inventory Value</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("users")} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong>Retail Value</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("locations")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong> Potential Profit</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("products")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className=" m-0 text-primary">
                    {" "}
                    <strong>Potential GM%</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("productCategory")}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row">
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white homeCard mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="text-primary m-0">
                    {" "}
                    <strong> Sales YTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("users")} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong>Sales MTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("locations")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong>Sales WTD</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("products")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className=" m-0 text-primary">
                    {" "}
                    <strong>Today Sales</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("productCategory")}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div> */}

          {/* </div> */}
        </div>
      </div>

      {/* <div> */}
      {/* <div className='name-section'>
                    <p style={{ marginTop: '100px', marginLeft: '10px', fontWeight: '700', fontSize: '1.5rem', }}>Hi, {firstName}</p>
                    <p style={{ marginTop: '20px', marginLeft: '10px' }}>Welcome to <b>{localStorage.getItem("companyName")}</b> dashboard</p> */}
      {/* <div className='first-box'></div>
                <div className='second-box'></div>
                <div className='third-box'></div>
                <div className='fourth-box'></div>
                <div className='fifth-box'></div>
                <div className='sixth-box'></div>
                <div className='seventh-box'></div>
                <div className='eight-box'></div>
                <div className='nineth-box'></div> */}
      {/* </div> */}
      {/* <div className='stat-area'>
                    <div className='stat-box'>
                        <p style={{ fontSize: '0.7rem', color: 'gray', fontFamily: 'Roboto' }}>TOTAL NO OF USERS</p>
                        <p style={{ fontWeight: '800' }}>{localStorage.getItem("users")}</p>
                    </div>
                    <div className='stat-box'>
                        <p style={{ fontSize: '0.7rem', color: 'gray', fontFamily: 'Roboto' }}>TOTAL NO OF LOCATIONS</p>
                        <p style={{ fontWeight: '800' }}>{localStorage.getItem("locations")}</p>
                    </div>
                    <div className='stat-box'>
                        <p style={{ fontSize: '0.7rem', color: 'gray', fontFamily: 'Roboto' }}>TOTAL NO OF PRODUCTS</p>
                        <p style={{ fontWeight: '800' }}>{localStorage.getItem("products")}</p>
                    </div>
                    <div className='stat-box'>
                        <p style={{ fontSize: '0.7rem', color: 'gray', fontFamily: 'Roboto' }}>TOTAL  PRODUCT CATEGORY</p>
                        <p style={{ fontWeight: '800' }}>{localStorage.getItem("productCategory")}</p>
                    </div>

                </div> */}

      {/* </div> */}
    </>
  );
};

function mapStateToProps(state) {
  return {
    firstName: state.userReducer.firstName,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdateUser(payload) {
    dispatch({ type: "UPDATE_USER", payload });
  },

  LoadUsers(payload) {
    dispatch({ type: "LOAD_USERS", payload });
  },
  AddUser(payload) {
    dispatch({ type: "ADD_USER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InventoryManager);
